import React from 'react'

export const FeatureContext = React.createContext()
export const FeatureConsumer = FeatureContext.Consumer

const FeatureProvider = ({ features = {}, ...props }) => {
  return <FeatureContext.Provider value={features} {...props} />
}

FeatureProvider.displayName = 'FeatureProvider'
FeatureContext.displayName = 'FeatureContext'

export default FeatureProvider
